import React from 'react';
import { Box, Rating, Typography } from '@drone-js/core';
import { StringFormatter } from '@agoda/react-handyman';
import { ReviewSourceDisplay } from 'component/page/detail/Review/Review.selectors';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';

interface OwnProps {
    reviewTitle: string;
    reviewScore: number;
    reviewSource: ReviewSourceDisplay;
    minimal?: boolean;
    recentReview?: boolean;
}

type Props = OwnProps;

const ELLIPSIS = '...';
const MAX_REVIEW_TITLE_TEXT_LENGTH = 60;

const ReviewCardTitle: React.FC<Props> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);
    const reviewCardTitle =
        props.minimal && props.reviewTitle.length > MAX_REVIEW_TITLE_TEXT_LENGTH
            ? props.reviewTitle.substring(0, MAX_REVIEW_TITLE_TEXT_LENGTH).concat(ELLIPSIS)
            : props.reviewTitle;

    return (
        <>
            {reviewCardTitle && (
                <Typography variant="body-default-strong" textColor="base.default" mt={!props.minimal ? '12' : undefined} lineClamp={props.recentReview ? 1 : undefined}>
                    {reviewCardTitle}
                </Typography>
            )}
            {props.reviewScore && props.reviewSource && (
                <Box mt="8" display="flex" alignItems="center" data-testid="review-card-title">
                    <Rating variant="star" score={props.reviewScore} label={cms[146543]} />
                    <Typography variant="caption-default-strong" textColor="base.subtle" display="inline-block" ms="4">
                        {StringFormatter.format(cms[272058], props.reviewScore, props.reviewSource)}
                    </Typography>
                </Box>
            )}
        </>
    );
};

ReviewCardTitle.displayName = 'ReviewCardTitle';
export default ReviewCardTitle;
